export default {
  apiUrl: null,
  googleClientId: null,
  facebookClientId: null,
  captchaKey: null,
};
